module.exports = __webpack_public_path__ + "img/8.cb30707c.jpg";